<template>
  <div :class="`div-input-width-logo${smallClass}`">
    <input
      v-show="false"
      id="inputFile"
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />
    <div :class="`div-input-logo${smallClass} center`">
      <div v-if="!imageUrl" @click="showFileChooser">
        <p class="text-small">
          Logo
        </p>
      </div>
      <div v-if="imageUrl" @click="showFileChooser">
        <v-img :class="`logo${smallClass} center`"
               :src="imageUrl"/>
      </div>
    </div>
    <px-upload-crop-modal v-model="openCrop"
                          :image="image"
                          :upload-path="uploadPath"
                          @close="closeCrop"
                          @change="onUploadImage"/>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    publicFilePath: {
      type: String,
      required: true,
    },
    uploadPath: {
      type: String,
      default: '/comprador/files/public',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      image: null,
      fileName: null,
      temporary: false,
      openCrop: false,
    };
  },
  computed: {
    imageUrl() {
      if (this.localValue && this.localValue.path) {
        return `${this.publicFilePath}${this.localValue.path}`;
      }
      return null;
    },
    localValue: {
      get() { return this.value; },
      set(localValue) { this.$emit('input', localValue); },
    },
    smallClass() {
      return this.small ? '-small' : '';
    },
  },
  methods: {
    onUploadImage(image) {
      this.closeCrop();
      this.localValue = image;
      this.$emit('uploaded-image', image);
    },
    closeCrop() {
      this.openCrop = false;
      document.getElementById('inputFile').value = '';
    },
    showFileChooser() {
      if (this.initialImage) {
        return;
      }
      this.$refs.input.click();
    },
    setImage(e) {
      const file = e.target.files[0];

      if (file.type.indexOf('image/') === -1) {
        this.$toast('O arquivo não é uma imagem', { color: 'error' });
        return;
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.image = event.target.result;
          this.fileName = file.name;
          this.openCrop = true;
        };

        reader.readAsDataURL(file);
      } else {
        this.$toast('FileReader not supported', { color: 'error' });
      }
    },
  },
};
</script>
<style scoped>
.div-input-width-logo {
  max-width: 70px;
  max-height: 70px;
  border-radius: 10px;
}

.div-input-width-logo-small {
  width: 50px;
  height: 50px;
  border-radius: 10px;
}

.logo-small {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  border-width: 1px;
  border-style: solid;
}

.div-input-logo-small {
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  height: 50px;
  top: auto;
  cursor: pointer;
}

.logo {
  max-width: 70px;
  max-height: 70px;
  border-radius: 10px;
  border-width: 1px;
  border-style: solid;
}

.div-input-logo {
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  height: 70px;
  top: auto;
  cursor: pointer;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-small {
  font-size: 13px;
  text-align: center;
  margin-top: 13px;
}

</style>
